import {Grid} from '@logistics-frontend/blocks'
import {Alert} from '@logistics-frontend/blocks/lpc/alert'
import {Divider} from '@logistics-frontend/blocks/lpc/divider'
import {useI18n} from '@logistics-frontend/core/i18n'
import {Snackbar} from '@material-ui/core'
import {SnackbarOrigin} from '@material-ui/core/Snackbar/Snackbar'
import {AsyncStatus, useEstimateQuery, useOffer} from '@yandex-taxi/react-integration-api'
import React, {useEffect, useState} from 'react'

import SuccessText from './SuccessText'

const position: SnackbarOrigin = {
  vertical: 'bottom',
  horizontal: 'right',
}

const Estimate: React.FC = () => {
  const t = useI18n()
  const [, {setValue}] = useOffer()
  const {data, status, error} = useEstimateQuery()
  const [errorMessage, setErrorMessage] = useState<string>('')
  const offer = data?.offer || ''

  useEffect(() => setValue(offer, true), [setValue, offer])
  useEffect(() => {
    if (status === AsyncStatus.ERROR && error) {
      const message =
        error['status'] === 401
          ? undefined
          : t('order.form.payment.dont_support_error', 'Данный способ оплаты не поддерживается')
      setValue('', true)
      setErrorMessage(message)
    }
  }, [error, t, status, setValue])

  return (
    <>
      <Grid spacing={1} container>
        <Snackbar
          anchorOrigin={position}
          autoHideDuration={6000}
          onClose={() => setErrorMessage('')}
          open={!!errorMessage}
        >
          <Alert severity="error" variant="filled">
            {errorMessage}
          </Alert>
        </Snackbar>
        {status === AsyncStatus.SUCCESS && data && <SuccessText data={data} />}
      </Grid>
      <Divider />
    </>
  )
}

export default Estimate
